module.exports = __webpack_public_path__ + "img/alentour20.307fa36c.jpg";